export default {

  beforeMount: function (el, binding, vnode) {
    // click event handler
    el.__clickOutsideOnClick = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }

    // register event listener
    document.body.addEventListener('click', el.__clickOutsideOnClick, {
      capture: true,
    })
    document.body.addEventListener('touchend', el.__clickOutsideOnClick, {
      capture: true,
    })
  },

  unmounted: function (el) {
    // remove event listener
    document.body.removeEventListener('click', el.__clickOutsideOnClick, {
      capture: true,
    })
    document.body.removeEventListener('touchend', el.__clickOutsideOnClick, {
      capture: true,
    })
  },
}
